import React, { createContext, useState, useEffect, useContext } from 'react';
import { getDomainInfo } from '../api/ssoAuth';
import { getRedirectUri } from '../utils/redirectHelper';
import { getDisplayCompanyName } from '../utils/branding';

const DomainContext = createContext();

export const useDomain = () => {
  const context = useContext(DomainContext);
  if (!context) {
    throw new Error('useDomain must be used within DomainProvider');
  }
  return context;
};

export const DomainProvider = ({ children }) => {
  const [domainConfig, setDomainConfig] = useState(null);
  const [domainLoading, setDomainLoading] = useState(true);

  useEffect(() => {
    const fetchDomainConfig = async () => {
      const redirectUri = getRedirectUri();
      
      // Extract domain from redirect URI or use window location
      let domain = window.location.hostname;
      if (redirectUri) {
        try {
          const url = new URL(redirectUri);
          domain = url.hostname;
        } catch (e) {
          console.warn("Could not parse redirect URI:", redirectUri);
        }
      }

      try {

        // domain = 'www.linkwave.in'; // Temporary hardcoded domain for testing

        const result = await getDomainInfo(domain);
        
        if (result.success && result.data) {
          setDomainConfig(result.data);
          
          // Update favicon if provided
          if (result.data.faviconIcon) {
            const existingLink = document.querySelector("link[rel~='icon']");
            if (existingLink) {
              existingLink.href = result.data.faviconIcon;
            } else {
              const link = document.createElement("link");
              link.rel = "icon";
              link.href = result.data.faviconIcon;
              document.head.appendChild(link);
            }
          }

          // Update document title if company name provided
          if (result.data.companyName) {
            const displayCompanyName = getDisplayCompanyName(
              result.data.companyName
            );
            document.title = `${displayCompanyName} - SSO`;
          }
        }
      } catch (error) {
        console.error("Error fetching domain config:", error);
      } finally {
        setDomainLoading(false);
      }
    };

    fetchDomainConfig();
  }, []);

  return (
    <DomainContext.Provider value={{ domainConfig, domainLoading }}>
      {children}
    </DomainContext.Provider>
  );
};
